import React, { useRef, useState } from "react";
import "../../../css/OfferMediaUploader.css";
import SampleImageCropper from "./SampleImageCropper";
import { Swiper, SwiperSlide } from "swiper/react";
import {
	EffectCards,
	EffectCoverflow,
	Navigation,
	Pagination,
} from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import OfferMediaCarousel from "./OfferMediaCarousel";

export default function OfferMediaUploader({ media, setMedia }) {
	const fileRef = useRef();

	const [current, setCurrent] = useState(0);

	const [cropImage, setCropImage] = useState(null);

	const [selectedFile, setSelectedFile] = useState(null);

	const handleSelect = (e) => {
		const files = Array.from(e.target.files);

		if (!files.length) return;

		if (media.length + files.length > 4) {
			alert("Maximum 4 media allowed.");
			return;
		}

		const first = files[0];

		const isImage = first.type.startsWith("image/");
		const isVideo = first.type.startsWith("video/");

		if (!isImage && !isVideo) {
			alert("Invalid file.");
			return;
		}

		if (isImage) {
			if (first.size > 10 * 1024 * 1024) {
				alert("Image should be below 10MB");
				return;
			}

			setSelectedFile(first);
			setCropImage(URL.createObjectURL(first));

			return;
		}

		if (isVideo) {
			if (first.size > 30 * 1024 * 1024) {
				alert("Video should be below 30MB");
				return;
			}

			setMedia((prev) => [
				...prev,
				{
					type: "video",
					file: first,
					preview: URL.createObjectURL(first),
				},
			]);
		}
	};

	const handleCropDone = (croppedFile) => {
		setMedia((prev) => [
			...prev,
			{
				type: "image",
				file: croppedFile,
				preview: URL.createObjectURL(croppedFile),
			},
		]);

		setCropImage(null);
		setSelectedFile(null);
	};

	const removeMedia = (index) => {
		const updated = media.filter((_, i) => i !== index);

		setMedia(updated);

		if (current >= updated.length) {
			setCurrent(0);
		}
	};

	return (
		<>
			<div className="sample-image-card-box mt-3">
				<h6 className="mb-3">Offer Images / Videos</h6>
				<div className="upload-grid">
					{Array.from({ length: 4 }).map((_, index) => (
						<div
							key={index}
							className="upload-slot"
							onClick={() => fileRef.current.click()}
						>
							{media[index] ? (
								media[index].type === "image" ? (
									<img src={media[index].preview} alt="" />
								) : (
									<video src={media[index].preview} />
								)
							) : (
								<div className="upload-plus">+</div>
							)}
						</div>
					))}
				</div>

				<input
					ref={fileRef}
					type="file"
					accept="image/*,video/*"
					hidden
					onChange={handleSelect}
				/>
				{media.length > 0 && (
					<div className="preview-box">
						<OfferMediaCarousel media={media} />

						<div className="text-center mt-3">
							<button
								type="button"
								className="remove-btn"
								onClick={() => removeMedia(current)}
							>
								Remove Current Media
							</button>
						</div>
					</div>
				)}
			</div>

			{cropImage && (
				<SampleImageCropper
					image={cropImage}
					file={selectedFile}
					onCropDone={handleCropDone}
					onClose={() => {
						setCropImage(null);
						setSelectedFile(null);
					}}
				/>
			)}
		</>
	);
}
